module.exports = __webpack_public_path__ + "media/images/font/Gustavo-Light-fa7dff51edc2112317dd2948b7fea111.woff";